import $ from 'jquery'
import TemplateView from "../../../TemplateView"
import ViewTTStore from "../ViewTTStore"
import TaskTooltip from './TaskTooltip'

export default class TaskRow extends TemplateView {

    constructor({
        taskModel = null,
        last = false,
    }) {
        super()

        this.params = {
            taskModel,
            last,
        }
    }

    afterRender() {
        const task = ViewTTStore.getTask(this.params.taskModel.taskId);
        this.$el.toggleClass("nonLast", !this.params.last);
        this.$el.addClass("task" + this.params.taskModel.taskId)

        if (task.canViewDetails) {
            this.$el.addClass("available")
            this.$el.click((e) => {this._onClick(e)});
        } else {
            this.tooltip = TaskTooltip.getInstance();
            this.tooltip.subscribeToMouseEvents(this.$el);
        }
    }

    _onClick(e) {
        $(document).trigger("viewTT.detailsTable.taskClick", [e, this.params.taskModel.taskId]);
    }
}


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/TaskRow.js